import { Box } from 'theme-ui';
import { useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { A11y } from 'swiper';
import { useProductSwiperParams } from '@snippets/ProductSwiper/useProductSwiperParams';
import { ProductTile } from './ProductTile';
import { themed } from './ProductCarousel.theme';

SwiperCore.use([A11y]);

export const ProductCarousel = themed(
  ({ theme, products, swiper, setSwiper, setIsStart, setIsEnd }) => {
    const count = products?.length >= 4;
    const defaultParams = useProductSwiperParams({
      isProductRecs: false,
      loopEnabled: false,
      count,
    });

    // Override navigation to disable default arrows
    const customParams = {
      ...defaultParams,
      navigation: false, // Disable default navigation arrows
    };

    // Handle swiper state changes
    const setStartAndEndOnSwiperChange = useCallback(() => {
      if (!swiper) return;

      setIsStart(swiper.isBeginning);
      setIsEnd(swiper.isEnd);

      swiper.on('slideChange', () => {
        setIsStart(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
      });
    }, [swiper, setIsStart, setIsEnd]);

    useEffect(() => {
      setStartAndEndOnSwiperChange();
    }, [setStartAndEndOnSwiperChange]);

    if (!products?.length) {
      return (
        <Box sx={{ textAlign: 'center', py: 4, color: '#666' }}>
          No products available
        </Box>
      );
    }

    return (
      <Box
        data-comp={ProductCarousel.displayName}
        sx={{ position: 'relative' }}
      >
        <Swiper onSwiper={setSwiper} a11y={{ enabled: true }} {...customParams}>
          {products.map((item, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  minWidth: ['min(280px,100%)', '300px'],
                  flexShrink: 0,
                }}
              >
                <ProductTile item={item} index={index} />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    );
  }
);

ProductCarousel.displayName = 'ProductCarouselToggle-ProductCarousel';
